import { render, staticRenderFns } from "./PlotForm.vue?vue&type=template&id=5bf83ede&scoped=true&"
import script from "./PlotForm.vue?vue&type=script&lang=js&"
export * from "./PlotForm.vue?vue&type=script&lang=js&"
import style0 from "./PlotForm.vue?vue&type=style&index=0&id=5bf83ede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf83ede",
  null
  
)

export default component.exports